import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'app/components/Button';
import BlueprintSelector from 'app/components/BlueprintSelector';
import PrivateCompanyContent from 'app/common/PrivateCompanyContent';
import type { MatchPreviewData } from 'app/components/MatchPreview/types';

import style from './style.scss';

interface Props {
  match: MatchPreviewData;
  updating: boolean;
  onSelectBlueprint: (id: number) => void;
  onBook: () => void;
}

const MatchActionBookmaker: FC<Props> = ({ match, updating, onSelectBlueprint, onBook }) => {
  const [t] = useTranslation();
  const { betting_metadata } = match;

  if (!betting_metadata || (!betting_metadata.blueprint && !betting_metadata.markets_created)) {
    return (
      <BlueprintSelector
        videogameSlug={match.videogame.slug}
        disabled={updating}
        onChange={onSelectBlueprint}
      />
    );
  }

  if (!betting_metadata.booked && betting_metadata.bookable) {
    return (
      <PrivateCompanyContent
        feature="BOOK_UNREVIEWED_MATCHES"
        condition={betting_metadata.pandascore_reviewed}
      >
        <Button
          className={style.button}
          disabled={!betting_metadata.bookable}
          loading={updating}
          onClick={onBook}
        >
          {t('events-match_book')}
        </Button>
      </PrivateCompanyContent>
    );
  }

  return null;
};

MatchActionBookmaker.displayName = 'MatchActionBookmaker';

export default MatchActionBookmaker;
